import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=2f3b7832&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"
import style0 from "./recordList.vue?vue&type=style&index=0&id=2f3b7832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b7832",
  null
  
)

export default component.exports